<template>
  <div>
    <Sticky>
      <nav class="navbar navbar-horizontal navbar-expand-lg" style="background: #1F212E;">
        <div class="container-fluid">
          <div
            class="navbar-brand text-white"
            :class="
              $route.path !== '/home' ? 'd-flex justify-content-between' : ''
            "
          >
            <div
              class="d-flex flex-column banking-icons my-auto ml-1 mr-3"
              v-if="$route.path !== '/auth/login'"
            >
              <i
                class="fas fa-chevron-left mx-auto my-1 text-xl text-muted"
                @click="$playSound(); $router.go(-1)"
                v-if="$route.path !== '/home'"
              ></i>
            </div>
            <img
              src="/build/assets/img/logo.webp"
              alt=""
              @click="$playSound(); $router.push('/home')"
            />
            <!-- LOGO -->
          </div>
          <div class="d-flex">

            <!-- Refresh  -->
            <!-- <div
              class="navbar-brand text-white mx-3 d-flex flex-column"
              @click="$router.go()"
            >
              <i class="fas fa-redo mx-auto"></i>
              <div>
                {{ $store.state.language === 'en' ? 'Refresh' : 'Refresh' }}
              </div>
            </div> -->
            <div class="d-flex" v-if="$route.path !== '/auth/login' && authUser">
              
              <span class="my-auto pr-3" style="border-right: 1px solid gray;">
                <span class="text-sm text-uppercase mr-1" style="color: #B7AAAA">
                  <img data-v-49989627="" loading="lazy" class="coin" src="data:image/png;base64,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" alt="">
                </span>

                <span class="text-white text-md">
                  <b>{{ Number($store.state.authUser.amount).toLocaleString() }}</b> MMK
                </span>
              </span>
            </div>
            

            <!-- Language -->
            <div
              class="nav-link d-flex justify-content-between"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
                  <div id="navbar-language">
                    <img
                        :src="$t('images.lang-img')"
                        alt=""
                        class="mr-2"
                        style="width: 25px; height: 25px; border-radius: 50%;"
                      />
                  </div>
                </div>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbar-language"
                >
                  <a class="dropdown-item" @click="setLangLocalstorage('en')"
                    ><img
                      src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/united-kingdom.png"
                      alt=""
                      class="mr-2"
                      style="width: 20px; height: 20px"
                    />
                    {{ $t("en") }}</a
                  >
                  <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="setLangLocalstorage('mm')"
                      ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/myanmar.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("mm") }}</a
                    >
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="setLangLocalstorage('cn')"
                      ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("cn") }}</a
                    >
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="setLangLocalstorage('th')"
                      ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("th") }}</a
                    >

                  </div>
                </div>
        </div>
      </nav>
    </Sticky>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Sticky },
  data() {
    return {
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    onOffMusic() {
      this.$store.commit('setMusic', !this.$store.state.music);
    },
    askNotificationPermission() {
        Notification.requestPermission().then(async (permission) => {
          if(permission === 'granted') {
            this.alreadyGranted = false;
           alert(
              this.$store.state.language === 'en'
                ? 'Notification permission granted!'
                : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
            );
          } else {
            alert(
              this.$store.state.language === 'en'
                ? 'Notification permission denied!'
                : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
            );
          }
        });
  },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if(this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => {});
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
  },
  async mounted() {
    if(window.Notification.permission === 'granted') {
      this.alreadyGranted = false;
    }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
.coin[data-v-49989627] {
    height: 1.3rem;
    margin-top: -0.25rem;
    margin-right: 0.4rem;
    animation: flip-coin-49989627 2.5s linear infinite;
    animation-delay: 0s;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
    transform-style: preserve-3d; /* Keeps the 3D effect */
}

/* Define the keyframes for the 3D flip animation */
@keyframes flip-coin-49989627 {
    0% {
        transform: rotateY(0deg); /* Front face */
    }
    50% {
        transform: rotateY(180deg); /* Back face */
    }
    100% {
        transform: rotateY(360deg); /* Front face again */
    }
}


/* CSS */
.login-btn {
  background: transparent;
  border: 1px solid #2c32df;
  border-radius: 3px;
  padding: .3rem 1.5rem;
  color: #2c32df;
}



.navbar {
  padding: 3px;
  padding-left: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  /* border-bottom: 2px solid black; */
}
.navbar-horizontal .navbar-brand img {
  height: 40px;
}
.nav-link {
  cursor: pointer;
}
.navbar-brand.brand-text {
  font-size: 20px;
  color: red;
  margin-left: 0px;
  margin-right: 10px;
}
.navbar-brand {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.dropdown-item {
  cursor: pointer;
}
.bg-default {
  background-color: #02133E !important;
}
@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 14px;
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
